import vuetify from './plugins/vuetify';
import ds from './plugins/designSystem';
import {eventListenerService, imageService, postMessageService} from './modules/common/services'
import {urlUtil, constants} from '@/modules/common/utils';

import '@/assets/scss/main.scss';

import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import "./plugins/index";
import "@/modules/common/filters";
import "@/modules/common/directives";
import "@/../styles/variables.scss";
import "@/../styles/safe-area.scss";
import 'requestidlecallback-polyfill';
import "@/modules/common/constants/momentLocalization";

const isPlatformMenuEnabledFromFeatureFlags = () => {
  try {
    return typeof store.getters.hasFeature === 'function'
      && store.getters.hasFeature('rollout.platform_administration.mobile_glassy_nav_layout');
  } catch (error) {
    return false;
  }
};

const isPlatformMenuEnabled = () => isPlatformMenuEnabledFromFeatureFlags();

const MOBILE_LAYOUT_METRICS_UPDATED = 'mobile-layout-metrics-updated';
const MOBILE_LAYOUT_METRIC_VARIABLES = [
  '--floating-mobile-bottom-bar-gap',
  '--floating-mobile-bottom-bar-height',
  '--floating-mobile-bottom-bar-bottom',
  '--floating-mobile-content-inset',
  '--floating-mobile-fab-bottom',
  '--floating-mobile-menu-spacer',
];

const applyMobileLayoutMetrics = (metrics = {}) => {
  MOBILE_LAYOUT_METRIC_VARIABLES.forEach((variableName) => {
    if (metrics[variableName]) {
      document.documentElement.style.setProperty(variableName, metrics[variableName]);
      document.body.style.setProperty(variableName, metrics[variableName]);
    }
  });
};

const syncPlatformMenuClass = () => {
  const enabled = isPlatformMenuEnabled();
  document.body.classList.toggle('platform-menu', enabled);
  const appRoot = document.getElementById('app');
  appRoot?.classList.toggle('platform-menu', enabled);
};

// env(safe-area-inset-*) resolves to 0 inside this nested iframe. Measure the
// real inset from the top-level (native shell) document and expose it locally.
const measureSafeAreaInsetBottom = () => {
  try {
    const topDocument = window.top.document;
    const probe = topDocument.createElement('div');
    probe.style.cssText = 'position:fixed;bottom:0;left:0;width:0;height:env(safe-area-inset-bottom,0px);visibility:hidden;pointer-events:none;';
    topDocument.body.appendChild(probe);
    const insetBottom = probe.getBoundingClientRect().height;
    probe.remove();
    return insetBottom;
  } catch (crossOriginInDev) {
    return 0;
  }
};

const syncSafeAreaInset = () => {
  document.documentElement.style.setProperty('--safe-area-inset-bottom', `${measureSafeAreaInsetBottom()}px`);
};

window.addEventListener('resize', syncSafeAreaInset);

store.watch(
  (state, getters) => (
    typeof getters.hasFeature === 'function'
      ? getters.hasFeature('rollout.platform_administration.mobile_glassy_nav_layout')
      : false
  ),
  () => {
    syncPlatformMenuClass();
  },
);

eventListenerService.addListener('on-frontage-message', (message) => {
  if (message.event === MOBILE_LAYOUT_METRICS_UPDATED) {
    applyMobileLayoutMetrics(message.data);
  }
});

const initFunc = async (hostBrand, app_config) => {
  window.hostBrand = hostBrand;
  window.app_config = app_config;
  await store.dispatch({type: 'brandModule/initBrand', brand: window.hostBrand})

  imageService.setFrontageImages(window.app_config.assets)
  constants.init(mobileApp, window.hostBrand, window.app_config)
  // await initI18N(urlUtil.getParameterByName("lang"));
  syncPlatformMenuClass();
  syncSafeAreaInset();
  new Vue({
    router,
    vuetify: ds,
    store,
    // i18n: getI18n(),
    render: h => h(App)
  }).$mount("#app");
  syncPlatformMenuClass();
  syncSafeAreaInset();
};

Vue.prototype.$log = Vue.prototype.$log || console.log;
Vue.config.productionTip = false;

const mobileApp = window.navigator.userAgent.match('vcitapp');
const mobileView = urlUtil.getParameterByName("MobileView") === "1";
const paneView = urlUtil.getParameterByName("PaneView") === "1";
const staffUid = urlUtil.getParameterByName("staffUid");
if (staffUid) {
  store.dispatch("auth/init", staffUid);
}
store.commit("setIsAndroid", ((navigator.userAgent.toLowerCase()).indexOf("android") > -1));
store.commit("setIsiPhone", !!window.navigator.userAgent.match('iPhone'));
store.commit("setIsiPad", !!window.navigator.userAgent.match(/Mac/) && !!window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2);
store.commit("setIsTouchScreen", window.matchMedia("(pointer: coarse)").matches);
store.commit("setChromeIos", !!window.navigator.userAgent.match('CriOS'));
store.commit("setMobile", mobileView);
store.commit("setMobileApp", mobileApp);
store.commit("setPane", paneView);
store.commit("setLang", urlUtil.getParameterByName("lang"));
if (urlUtil.getParameterByName("lang") === 'he'){
  store.commit("setDirection",'rtl');
}

initFunc(window.parent.hostBrand, window.parent.app_config);
